import React, { useMemo, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Container,
  Divider,
  Grid,
  Slider,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PersonIcon from "@mui/icons-material/Person";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import SecurityIcon from "@mui/icons-material/Security";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import StarIcon from "@mui/icons-material/Star";
import ArticleIcon from "@mui/icons-material/Article";

import asianWomanHappy from "../src/img/asian2.png";
import singpassmobilepage from "../../../assets/img/Singpasslogin-screenshot.png";
import platformFee from "../src/img/0platformfee.png";
import coinShadow from "../src/img/coin shadow.png";
import bank_image from "../src/img/11.png";
import bank_image1 from "../src/img/12.png";
import bank_image2 from "../src/img/13.png";
import bank_image3 from "../src/img/14.png";
import bank_image4 from "../src/img/15.png";
import bank_image5 from "../src/img/16.png";
import bank_image6 from "../src/img/17.png";
import bank_image7 from "../src/img/18.png";
import bank_image8 from "../src/img/19.png";

const PRIMARY_COLOR = "rgb(45, 128, 195)";
const SECONDARY_COLOR = "rgb(237, 182, 0)";

const conciergeBenefit = [
  {
    id: 1,
    title: "Dedicated RM, Unified Inbox",
    description:
      "We liaise with lenders so you can focus on your business and await approval stress-free.",
    icon: <PersonIcon fontSize="small" sx={{ color: PRIMARY_COLOR }} />,
  },
  {
    id: 2,
    title: "Pre-Qualified Loan Matches",
    description:
      " Say goodbye to generic rejections. We connect you only with lenders you're eligible for.",
    icon: <AutoGraphIcon fontSize="small" sx={{ color: PRIMARY_COLOR }} />,
  },
  {
    id: 3,
    title: "Priority Processing & Faster Turnarounds",
    description:
      " Jump the queue with concierge support—your application gets flagged for faster review and faster disbursal.",
    icon: <SecurityIcon fontSize="small" sx={{ color: PRIMARY_COLOR }} />,
  },
  {
    id: 4,
    title: "Smart Monitoring & Early Refinance Alerts",
    description:
      " Get notified when you're eligible for better terms. We track your loan health and flag refinance opportunities early. Jump the queue with concierge support—your application gets flagged for faster review and faster disbursal.",
    icon: <RestartAltIcon fontSize="small" sx={{ color: PRIMARY_COLOR }} />,
  },
];

const borrowerSteps = [
  {
    step: 1,
    title: "Register your account",
    description:
      "Create your SmartLend account quickly and securely with 2FA to begin your seamless borrowing journey.",
  },
  {
    step: 2,
    title: "Apply via Singpass",
    description:
      "Use MyInfo Business for a quick, hassle-free process—no data entry, just a few clicks.",
  },
  {
    step: 3,
    title: "Upload basic financial documents",
    description: "Attached your business's Latest 6 Months Bank Statements.",
  },
  {
    step: 4,
    title: "Complimentary Credit Bureau Report",
    description:
      "Access and Upload your free Personal Credit Bureau Report seamlessly through our secure platform.",
  },
  {
    step: 5,
    title: "Viola! Choose your offer",
    description:
      "Enjoy the simplicity of selecting from multiple tailored loan offers, empowering you to make the best financial decision for your business with SmartLend.",
  },
];

const ourTrustedClient = [
  {
    id: 1,
    logo: "https://www.shutterstock.com/image-photo/asian-handsome-man-standing-cross-600nw-2147851005.jpg",
    rating: 5,
    name: "Adam Chang",
    company_title: "Wholesale of Beverage Owner",
    message:
      "Super easy to apply — I just scanned my Singpass and was done in under 3 minutes! Way better than other sites where I had to key in all my personal and company info manually. Best part? I got multiple offer to compare within a day.",
  },
  {
    id: 2,
    logo: "https://cdn.openart.ai/uploads/image_4EVpBDIM_1695127322837_512.webp",
    rating: 5,
    name: "Fatimah",
    company_title: "Wedding Planner Owner",
    message:
      "I needed short-term funding for my seasonal business and decided to try SmartLend instead of going through a loan broker. Got the funding I needed in just 5 days — and best of all, no hefty third-party fees.",
  },
  {
    id: 3,
    logo: "https://st.depositphotos.com/1597387/3834/i/950/depositphotos_38340535-stock-photo-young-asian-man-close-up.jpg",
    rating: 5,
    name: "Alfred Ong",
    company_title: "Construction Firm Owner",
    message:
      "I was a bit skeptical about their concierge service at first, but overall I’m happy as they delivered what they promised. There were some hiccups along the way, but the SmartLend team really pushed to get me the tenor I needed.",
  },
  {
    id: 4,
    logo: "https://as1.ftcdn.net/jpg/02/79/90/20/1000_F_279902034_kBjKUJvC8y19AdkEJ3L3emqxVqY5K7Cv.jpg",
    rating: 5,
    name: "Raj Kumar",
    company_title: "F&B Business Owner",
    message:
      "Got rejected by the banks, but SmartLend helped me secure a small loan to tide over until our invoices came in. Really thankful they made it happen when we needed it most.",
  },
  {
    id: 5,
    logo: "https://media.istockphoto.com/id/1313502972/photo/portrait-of-beautiful-woman-having-fun.jpg?s=612x612&w=0&k=20&c=DHGWp3wIoSlpjK9xFdARpgpyo4t-hIzuqOSx5ZyRsHA=",
    rating: 4.9,
    name: "Sri Laksmi",
    company_title: "Retail of Dried & Fresh Flowers Owner",
    message:
      "SmartLend made the whole process super easy and fast — I applied in minutes, compared loan offers, and even negotiated terms, all on one platform. I could see my repayment schedule clearly and track everything in one place. It really puts the power back in the borrower’s hands!",
  },
  {
    id: 6,
    logo: null,
    rating: 5,
    name: "Hong Wang Goh",
    company_title: "General",
    message:
      "Victoria is very helpful and patient. She has put in a lot of effort to help sourcing for funds for my business. Highly recommend for sme business owners to approach her for funding needs.",
  },
];

const moreReviewsFromGoogle = [
  {
    id: 1,
    name: "Md. Abdullah Al Mahmud",
    description:
      "I recently contacted Mr. Jason regarding a small loan, and I must say he is one of the most courteous and professional individuals I’ve met. He patiently listened to my situation and offered valuable advice. He then connected me with Mr. Kuah, who supported me throughout the entire loan process with great dedication and sincerity. Mr. Kuah maintained consistent communication with the bank and kept me well-informed every step of the way. Thanks to both of them, the whole process was smooth and stress-free. Exceptional service from start to finish — a well-deserved 5 stars!",
    image: "",
    rating: 4,
    when: "2 weeks ago",
  },
  {
    id: 2,
    name: "Barbara Ng",
    description:
      "I recently used Smart-Towkay's brokerage service and had an excellent experience, thanks to the guidance of Junior Kuah. I was impressed by their professionalism and efficiency. Junior was friendly and helpful, answering all my questions and guiding me through the process. One thing that stood out was their attention to detail and ability to find a great solution for my needs. I would highly recommend Smart-Towkay's brokerage service, especially Junior Kuah, to others because of their expertise and customer-centric approach.",
    image: "",
    rating: 5,
    when: "Edited a week ago",
  },
  {
    id: 3,
    name: "Tan Boon Thye",
    description:
      "Thankful for the service and guidance on my business, appreciate the time taken for both Jason and Jackie. As I mainly focus on operations, business financial is definitely well taken care of by Smart Towkay! If you are planning to know more on what services they could provide, do consult and look out for them! 101% recommended!",
    image: "",
    rating: 5,
    when: "a month ago",
  },
];

const faqs = [
  {
    id: 1,
    title: "How do I apply for a Business Loan?",
    answer:
      "Get started by clicking on the sign up button above and it will take you through a step by step process to sign up for a smartlend account. Once you’re done with your sign up, you can head on into the dashboard and click on the apply loan button located on the menu bar on the left.",
  },
  {
    id: 2,
    title: "Can anyone apply for a Business Loan?",
    answer:
      "Currently, only Singapore locally incorporated LLP (Limited Liability Partnership) or Pte. Ltd. (Private Limited) entities are eligible to apply for a business loan. However, if you have a different type of corporate entity, please reach out to us at support@smart-lend.com, and we'll explore how we might be able to assist you.",
  },
  {
    id: 3,
    title: "Why can’t I apply for a loan?",
    answer:
      "If you're unable to apply for a loan, it usually means that you haven't synchronized your Corp Pass account with your Singpass yet. This synchronization process is necessary for accessing and applying for loans.",
  },
  {
    id: 4,
    title: "Can I speak to the lenders of the platform?",
    answer:
      "Yes, you can speak to the lenders on our platform, but only if the lender has expressed interest in your loan request. In such cases, a chatbot request feature will be enabled on our platform. However, please note that we do not provide users with the private contact information of our lenders due to our privacy policies.",
  },
  {
    id: 5,
    title: "How can I talk to my private lender?",
    answer:
      "If you would like to reach your lender on the loan offer that they have offered, you can click on the offer in the requested loan page, select the lender, and proceed to click on the negotiation button where you’ll be taken to the messaging page where you can start a conversation with your lender.",
  },
  {
    id: 6,
    title: "My loan has disappeared, where did it go?",
    answer:
      "If you can't find your loan, don't worry! Once a loan is approved by both the borrower and lender, it is moved to the accepted loan page. Here, you can check the status of your loan, which will indicate the stage it's in before being disbursed. After your loan is disbursed, it will be moved to the \"loan in progress\" page. Here, you'll find detailed information about your loan and can make payments accordingly.",
  },
  {
    id: 7,
    title: "How long does it take for me to get a loan approved?",
    answer:
      "The approval time for your loan depends on several factors. First, you need to receive an offer from a lender. At Smart-Lend, we have a wide network of lenders who review your financial profile and the documents you've provided before making an offer. This process usually takes between 1 to 5 working days. Keep an eye out for our upcoming Service Guarantee feature! Soon, borrowers will enjoy even faster turnaround times, with approvals possible within 24 hours. Stay tuned for more details when we introduce this new feature.",
  },
];

const featuredLogos = [
  {
    src: bank_image,
    href: "https://www.straitstimes.com/paid-press-releases/disrupting-sme-lending-smartlend-launches-free-digital-loan-platform-20250612",
  },
  {
    src: bank_image1,
    href: "https://www.moneyfm893.sg/pr-newswire/disrupting-sme-lending-smartlend-launches-free-digital-loan-platform-23753/",
  },
  {
    src: bank_image2,
    href: "https://www.theasianbanker.com/mediafeed-news/details?rkey=20250612AE09075&filter=23792",
  },
  {
    src: bank_image3,
    href: "https://themalaysianreserve.com/2025/06/12/disrupting-sme-lending-smartlend-launches-free-digital-loan-platform/",
  },
  {
    src: bank_image4,
    href: "https://techcollectivesea.com/2025/05/20/sme-financing-southeast-asia/",
  },
  {
    src: bank_image5,
    href: "https://thefinance.sg/pr-newswire/?rkey=20250612AE09075&filter=19895",
  },
  {
    src: bank_image6,
    href: "https://www.smehorizon.com/matching-smes-to-capital-with-alternative-financing-platforms/",
  },
  {
    src: bank_image7,
    href: "https://finance.yahoo.com/news/disrupting-sme-lending-smartlend-launches-080300477.html",
  },
  {
    src: bank_image8,
    href: "https://vulcanpost.com/newswire/?rkey=20250612AE09075&filter=25525",
  },
];

const heroHighlights = [
  "No Hidden Platform Fees",
  "70% of borrowers receive an offer within 48 hours",
  "Apply once, compare multiple alternative lenders",
];

const conciergeFeeTiers = [
  { range: "Below S$ 20,000", fee: "1.0 %" },
  { range: "S$ 20,000 to S$ 49,999", fee: "1.5 %" },
  { range: "S$ 50,000 and above", fee: "2.0 %" },
];

const TestingHomepage = () => {
  const isMobile = useMediaQuery("(max-width:900px)");
  const [amountForCalculation, setAmountForCalculation] = useState(1000);

  const conciergeFee = useMemo(() => {
    if (amountForCalculation < 20000) {
      return (amountForCalculation * 0.01).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }
    if (amountForCalculation < 49999) {
      return (amountForCalculation * 0.015).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }
    return (amountForCalculation * 0.02).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }, [amountForCalculation]);

  return (
    <Box sx={{ bgcolor: "#f5f8fb", minHeight: "100vh" }}>
      <Box
        sx={{
          position: "relative",
          overflow: "hidden",
          bgcolor: PRIMARY_COLOR,
          color: "white",
          pt: { xs: 12, md: 16 },
          pb: { xs: 10, md: 14 },
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={6}>
              <Stack spacing={3}>
                <Chip
                  label="SmartLend Platform Preview"
                  sx={{
                    alignSelf: "flex-start",
                    bgcolor: "rgba(255,255,255,0.16)",
                    color: "white",
                    fontWeight: 600,
                    letterSpacing: 1,
                  }}
                />
                <Typography variant={isMobile ? "h4" : "h3"} fontWeight={800} lineHeight={1.2}>
                  Apply Once, Access All.
                </Typography>
                <Typography variant="h6" fontWeight={400} sx={{ opacity: 0.9 }}>
                  Elevate your business's financial potential with SmartLend. Simplify your application process seamlessly, unlocking a variety of loan possibilities with minimal data input. Your choices, your empowerment – and all at no cost.
                </Typography>
                <Stack direction={isMobile ? "column" : "row"} spacing={2} alignItems={isMobile ? "stretch" : "center"}>
                  <Button
                    variant="contained"
                    color="inherit"
                    endIcon={<ArrowForwardIcon />}
                    href="/auth/signin"
                    sx={{
                      color: PRIMARY_COLOR,
                      fontWeight: 700,
                      borderRadius: 3,
                      px: 4,
                      py: 1.5,
                    }}
                  >
                    Apply now
                  </Button>
                  <Button
                    variant="outlined"
                    color="inherit"
                    href="https://wa.me/6587853373"
                    sx={{
                      borderColor: "rgba(255,255,255,0.6)",
                      color: "white",
                      fontWeight: 700,
                      borderRadius: 3,
                      px: 4,
                      py: 1.5,
                    }}
                  >
                    Talk to an Expert
                  </Button>
                </Stack>
                <Stack direction={isMobile ? "column" : "row"} spacing={1.5} alignItems="flex-start">
                  {heroHighlights.map((item) => (
                    <Chip
                      key={item}
                      icon={<CheckCircleIcon sx={{ color: SECONDARY_COLOR }} />}
                      label={item}
                      sx={{
                        bgcolor: "rgba(255,255,255,0.12)",
                        color: "white",
                        borderRadius: 2,
                        px: 1,
                        py: 0.5,
                        fontWeight: 500,
                      }}
                    />
                  ))}
                </Stack>
              </Stack>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Box
                  component="img"
                  src={asianWomanHappy}
                  alt="SmartLend borrower"
                  sx={{
                    width: { xs: "80%", md: "70%" },
                    maxWidth: 420,
                    borderRadius: 4,
                    boxShadow: "0 40px 80px rgba(0,0,0,0.25)",
                  }}
                />
                <Box
                  component="img"
                  src={singpassmobilepage}
                  alt="Singpass login"
                  sx={{
                    display: { xs: "none", md: "block" },
                    position: "absolute",
                    bottom: -40,
                    right: -60,
                    width: 220,
                    borderRadius: 3,
                    boxShadow: "0 25px 50px rgba(0,0,0,0.35)",
                    border: "6px solid rgba(255,255,255,0.6)",
                  }}
                />
                <Box
                  component="img"
                  src={platformFee}
                  alt="0% platform fee"
                  sx={{
                    position: "absolute",
                    top: -40,
                    right: { xs: 0, md: "auto" },
                    left: { xs: "50%", md: -60 },
                    transform: { xs: "translateX(-50%)", md: "none" },
                    width: 120,
                  }}
                />
                <Box
                  component="img"
                  src={coinShadow}
                  alt="Coin shadow"
                  sx={{
                    display: { xs: "none", md: "block" },
                    position: "absolute",
                    top: -70,
                    left: 120,
                    width: 90,
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ py: { xs: 8, md: 10 } }}>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant={isMobile ? "h4" : "h3"} fontWeight={800} color={PRIMARY_COLOR} gutterBottom>
              Unlock the Power of Smart Borrowing
            </Typography>
            <Typography variant="body1" sx={{ color: "rgba(0,0,0,0.7)", mb: 4 }}>
              Say goodbye to the headaches of dealing with Relationship Managers and brokers for your business loan needs. Introducing <strong>SMARTLEND</strong>, your compass in the world of SME financing. We've revolutionized the lending game, matching you with alternative lending options tailored for your business.
            </Typography>
            <Stack spacing={3}>
              {borrowerSteps.map((item) => (
                <Stack key={item.step} direction="row" spacing={2} alignItems="flex-start">
                  <Box
                    sx={{
                      bgcolor: PRIMARY_COLOR,
                      color: "white",
                      width: 56,
                      height: 56,
                      borderRadius: 2,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: 700,
                      fontSize: 20,
                    }}
                  >
                    {item.step}
                  </Box>
                  <Box>
                    <Typography variant="h6" fontWeight={700} color="rgba(0,0,0,0.85)">
                      {item.title}
                    </Typography>
                    <Typography variant="body2" color="rgba(0,0,0,0.7)">
                      {item.description}
                    </Typography>
                  </Box>
                </Stack>
              ))}
            </Stack>
            <Stack direction={isMobile ? "column" : "row"} spacing={2} sx={{ mt: 4 }}>
              <Button
                variant="outlined"
                href="/auth/signin"
                sx={{
                  borderColor: PRIMARY_COLOR,
                  color: PRIMARY_COLOR,
                  borderRadius: 3,
                  px: 4,
                }}
              >
                Apply now
              </Button>
              <Button
                variant="contained"
                href="/auth/signup"
                sx={{
                  bgcolor: SECONDARY_COLOR,
                  color: "black",
                  fontWeight: 700,
                  borderRadius: 3,
                  px: 4,
                }}
              >
                Register as Borrower
              </Button>
            </Stack>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                borderRadius: 4,
                boxShadow: "0 30px 60px rgba(45,128,195,0.15)",
                overflow: "hidden",
              }}
            >
              <Box component="img" src={singpassmobilepage} alt="Singpass quick apply" sx={{ width: "100%" }} />
              <CardContent>
                <Typography variant="h6" fontWeight={700} color={PRIMARY_COLOR} gutterBottom>
                  Apply Once, Access All.
                </Typography>
                <Typography variant="body2" color="rgba(0,0,0,0.7)">
                  Enjoy the simplicity of selecting from multiple tailored loan offers, empowering you to make the best financial decision for your business with SmartLend.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>

      <Box sx={{ bgcolor: PRIMARY_COLOR, color: "white", py: { xs: 8, md: 10 } }}>
        <Container maxWidth="lg">
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={6}>
              <Typography variant={isMobile ? "h4" : "h3"} fontWeight={800} gutterBottom>
                Upgrade to <Box component="span" sx={{ color: SECONDARY_COLOR }}>Concierge</Box>
              </Typography>
              <Typography variant="h6" fontWeight={500} gutterBottom>
                Your Fast-Track to Funding
              </Typography>
              <Typography variant="body1" sx={{ opacity: 0.85, mb: 4 }}>
                Enjoy one-on-one RM support, pre-approval checks, and direct lender negotiations.
              </Typography>
              <Stack direction={isMobile ? "column" : "row"} spacing={2} sx={{ mb: 4 }}>
                <Button
                  variant="outlined"
                  sx={{
                    borderColor: SECONDARY_COLOR,
                    color: SECONDARY_COLOR,
                    borderRadius: 3,
                    px: 4,
                  }}
                  href="/auth/signin"
                >
                  Learn more
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: SECONDARY_COLOR,
                    color: "black",
                    fontWeight: 700,
                    borderRadius: 3,
                    px: 4,
                  }}
                  href="/auth/signin"
                >
                  Get Concierge Access
                </Button>
              </Stack>
              <Grid container spacing={2}>
                {conciergeBenefit.map((item) => (
                  <Grid item xs={12} sm={6} key={item.id}>
                    <Stack direction="row" spacing={2}>
                      <Box
                        sx={{
                          bgcolor: "white",
                          borderRadius: 2,
                          width: 40,
                          height: 40,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {item.icon}
                      </Box>
                      <Box>
                        <Typography variant="subtitle1" fontWeight={700}>
                          {item.title}
                        </Typography>
                        <Typography variant="body2" sx={{ opacity: 0.8 }}>
                          {item.description}
                        </Typography>
                      </Box>
                    </Stack>
                  </Grid>
                ))}
              </Grid>
            </Grid>
            <Grid item xs={12} md={6}>
              <Card
                sx={{
                  bgcolor: "rgba(255,255,255,0.08)",
                  borderRadius: 4,
                  p: { xs: 4, md: 6 },
                  backdropFilter: "blur(12px)",
                }}
              >
                <Typography variant="h6" fontWeight={700} gutterBottom>
                  Concierge Service Success-Based Fee Structure
                </Typography>
                <Divider sx={{ borderColor: "rgba(255,255,255,0.2)", mb: 2 }} />
                <Stack spacing={1.5}>
                  {conciergeFeeTiers.map((tier) => (
                    <Stack
                      key={tier.range}
                      direction="row"
                      justifyContent="space-between"
                      sx={{
                        bgcolor: "rgba(255,255,255,0.06)",
                        borderRadius: 2,
                        px: 2,
                        py: 1.5,
                      }}
                    >
                      <Typography variant="body2" color="rgba(255,255,255,0.9)">
                        {tier.range}
                      </Typography>
                      <Typography variant="body2" fontWeight={700} color={SECONDARY_COLOR}>
                        {tier.fee}
                      </Typography>
                    </Stack>
                  ))}
                </Stack>
                <Divider sx={{ borderColor: "rgba(255,255,255,0.2)", my: 3 }} />
                <Typography variant="subtitle1" fontWeight={700} gutterBottom>
                  Simulate Concierge Fees
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.8, mb: 2 }}>
                  Adjust the loan amount to see your success-based concierge fee.
                </Typography>
                <Stack spacing={2}>
                  <Slider
                    value={amountForCalculation}
                    onChange={(_, value) => {
                      const nextValue = Array.isArray(value) ? value[0] : value;
                      setAmountForCalculation(nextValue);
                    }}
                    min={1000}
                    max={200000}
                    step={1000}
                    sx={{ color: SECONDARY_COLOR }}
                  />
                  <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="body2">S$ 1,000</Typography>
                    <Typography variant="body2">S$ 200,000</Typography>
                  </Stack>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Typography variant="body2">Loan Amount (S$)</Typography>
                    <input
                      value={amountForCalculation}
                      onChange={(event) => {
                        const nextValue = Number(event.target.value.replace(/[^0-9]/g, "")) || 0;
                        const clampedValue = Math.min(Math.max(nextValue, 1000), 200000);
                        setAmountForCalculation(clampedValue);
                      }}
                      style={{
                        width: 120,
                        borderRadius: 8,
                        border: "1px solid rgba(255,255,255,0.5)",
                        background: "transparent",
                        color: "white",
                        padding: "6px 12px",
                      }}
                    />
                  </Stack>
                  <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="body2" sx={{ opacity: 0.8 }}>
                      Success-based Concierge Fees
                    </Typography>
                    <Typography variant="h4" fontWeight={800} color={SECONDARY_COLOR}>
                      S$ {conciergeFee}
                    </Typography>
                  </Stack>
                </Stack>
                <Typography variant="caption" sx={{ display: "block", mt: 3, opacity: 0.8 }}>
                  <strong>Disclaimer:</strong> Fees are success-based and only applicable upon full disbursement of the approved loan amount. No fees will be charged if the borrower does not proceed with the signing or disbursement.
                </Typography>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ py: { xs: 8, md: 10 } }}>
        <Typography variant={isMobile ? "h4" : "h3"} fontWeight={800} color={PRIMARY_COLOR} gutterBottom>
          Loved by #SmartBorrowers
        </Typography>
        <Typography variant="body1" color="rgba(0,0,0,0.7)" sx={{ mb: 4 }}>
          Hear from SMEs who discovered faster financing, transparent offers, and concierge care on SmartLend.
        </Typography>
        <Grid container spacing={4}>
          {ourTrustedClient.map((client) => (
            <Grid item xs={12} sm={6} md={4} key={client.id}>
              <Card
                sx={{
                  height: "100%",
                  borderRadius: 4,
                  boxShadow: "0 20px 50px rgba(45,128,195,0.12)",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <CardContent sx={{ flexGrow: 1 }}>
                  <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
                    <Avatar src={client.logo || undefined} alt={client.name} sx={{ width: 48, height: 48 }}>
                      {client.logo ? null : client.name[0]}
                    </Avatar>
                    <Box>
                      <Typography variant="subtitle1" fontWeight={700}>
                        {client.name}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {client.company_title}
                      </Typography>
                    </Box>
                    <Chip
                      label={`${client.rating} ★`}
                      size="small"
                      sx={{ ml: "auto", bgcolor: "rgba(237,182,0,0.12)", color: SECONDARY_COLOR }}
                    />
                  </Stack>
                  <Typography variant="body2" color="rgba(0,0,0,0.7)">
                    {client.message}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      <Box sx={{ bgcolor: "#f0f5fb", py: { xs: 8, md: 10 } }}>
        <Container maxWidth="lg">
          <Typography variant={isMobile ? "h4" : "h3"} fontWeight={800} color={PRIMARY_COLOR} gutterBottom>
            More reviews from Google
          </Typography>
          <Grid container spacing={4}>
            {moreReviewsFromGoogle.map((review) => (
              <Grid item xs={12} md={4} key={review.id}>
                <Card sx={{ borderRadius: 4, height: "100%", display: "flex", flexDirection: "column" }}>
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 2 }}>
                      <Avatar>{review.name[0]}</Avatar>
                      <Box>
                        <Typography variant="subtitle1" fontWeight={700}>
                          {review.name}
                        </Typography>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Stack direction="row" spacing={0.5}>
                            {Array.from({ length: Math.round(review.rating) }).map((_, index) => (
                              <StarIcon key={index} fontSize="small" sx={{ color: SECONDARY_COLOR }} />
                            ))}
                          </Stack>
                          <Typography variant="caption" color="text.secondary">
                            {review.when}
                          </Typography>
                        </Stack>
                      </Box>
                    </Stack>
                    <Typography variant="body2" color="rgba(0,0,0,0.7)">
                      {review.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ py: { xs: 8, md: 10 } }}>
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={5}>
            <Typography variant={isMobile ? "h4" : "h3"} fontWeight={800} color={PRIMARY_COLOR} gutterBottom>
              As featured on
            </Typography>
            <Typography variant="body1" color="rgba(0,0,0,0.7)" sx={{ mb: 3 }}>
              SmartLend is making headlines for transforming SME financing with a free digital loan platform.
            </Typography>
            <Stack spacing={2}>
              <Stack direction="row" spacing={1} alignItems="center">
                <ArticleIcon sx={{ color: PRIMARY_COLOR }} />
                <Typography variant="body2" color="rgba(0,0,0,0.7)">
                  Disrupting SME lending with an end-to-end digital marketplace.
                </Typography>
              </Stack>
              <Stack direction="row" spacing={1} alignItems="center">
                <ArticleIcon sx={{ color: PRIMARY_COLOR }} />
                <Typography variant="body2" color="rgba(0,0,0,0.7)">
                  Matching SMEs to capital with alternative financing platforms.
                </Typography>
              </Stack>
            </Stack>
          </Grid>
          <Grid item xs={12} md={7}>
            <Grid container spacing={2} justifyContent="center">
              {featuredLogos.map((item, index) => (
                <Grid item xs={4} sm={3} md={4} key={`${item.href}-${index}`}>
                  <Box
                    component="a"
                    href={item.href}
                    target="_blank"
                    rel="noreferrer"
                    sx={{
                      display: "block",
                      borderRadius: 3,
                      bgcolor: "white",
                      p: 1.5,
                      boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
                      transition: "transform 0.3s ease",
                      "&:hover": { transform: "translateY(-6px)" },
                    }}
                  >
                    <Box component="img" src={item.src} alt="Press feature" sx={{ width: "100%", borderRadius: 2 }} />
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>

      <Box sx={{ bgcolor: "white", py: { xs: 8, md: 10 } }}>
        <Container maxWidth="lg">
          <Grid container spacing={6}>
            <Grid item xs={12} md={5}>
              <Typography variant={isMobile ? "h4" : "h3"} fontWeight={800} color={PRIMARY_COLOR} gutterBottom>
                Frequently Asked Questions
              </Typography>
              <Typography variant="body1" color="rgba(0,0,0,0.7)">
                Answers to the most common questions about applying for business loans through SmartLend.
              </Typography>
            </Grid>
            <Grid item xs={12} md={7}>
              <Stack spacing={2}>
                {faqs.map((faq) => (
                  <Box key={faq.id} sx={{ borderRadius: 3, border: "1px solid rgba(0,0,0,0.08)", p: 3 }}>
                    <Typography variant="subtitle1" fontWeight={700} gutterBottom>
                      {faq.title}
                    </Typography>
                    <Typography variant="body2" color="rgba(0,0,0,0.7)">
                      {faq.answer}
                    </Typography>
                  </Box>
                ))}
              </Stack>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Box sx={{ bgcolor: PRIMARY_COLOR, color: "white", py: { xs: 8, md: 10 } }}>
        <Container maxWidth="lg">
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={8}>
              <Typography variant={isMobile ? "h4" : "h3"} fontWeight={800} gutterBottom>
                Ready to experience the SmartLend advantage?
              </Typography>
              <Typography variant="body1" sx={{ opacity: 0.85 }}>
                Apply once and access a network of alternative lenders, concierge experts, and transparent offers tailored to your business.
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Stack direction={isMobile ? "column" : "row"} spacing={2}>
                <Button
                  variant="contained"
                  color="inherit"
                  href="/auth/signin"
                  sx={{
                    color: PRIMARY_COLOR,
                    fontWeight: 700,
                    borderRadius: 3,
                    px: 4,
                  }}
                >
                  Get Started
                </Button>
                <Button
                  variant="outlined"
                  color="inherit"
                  href="mailto:support@smart-lend.com"
                  sx={{
                    borderColor: "rgba(255,255,255,0.6)",
                    color: "white",
                    borderRadius: 3,
                    px: 4,
                  }}
                >
                  Contact Us
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default TestingHomepage;

